import { Injectable } from '@angular/core';
import { Route, UrlSegment } from '@angular/router';
import { FeatureFlagFieldType } from '@vendasta/meetings';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BookMeNowStoreService } from './book-me-now-store.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceTabFeatureFlagGuard {
  constructor(private readonly bookmenowService: BookMeNowStoreService) {}

  canMatch(_route: Route, segments: UrlSegment[]): Observable<boolean> {
    const routePrefix = segments[0]?.path;

    if (routePrefix === 'service') {
      const serviceId = segments[1]?.path;
      if (!serviceId) {
        return of(false);
      }
      return this.checkMultiServiceFlag(
        FeatureFlagFieldType.FEATURE_FLAG_FIELD_TYPE_SERVICE_ID,
        serviceId
      );
    }

    if (routePrefix === 'group') {
      // segments: ['group', groupId, groupSlug]
      const groupId = segments[1]?.path;
      if (!groupId) {
        return of(false);
      }
      return this.checkMultiServiceFlag(
        FeatureFlagFieldType.FEATURE_FLAG_FIELD_TYPE_GROUP_ID,
        groupId
      ).pipe(catchError(() => of(false)));
    }
    if (routePrefix === 'book' || routePrefix === 'reschedules') {
      const calendarId = segments[1]?.path;
      if (!calendarId) {
        return of(false);
      }
      return this.checkMultiServiceFlag(
        FeatureFlagFieldType.FEATURE_FLAG_FIELD_TYPE_CALENDAR_ID,
        calendarId
      );
    }

    // /:calendarId catch-all — routePrefix IS the calendarId
    const staticRoutes = new Set([
      'terms',
      'privacy-policy',
      'terms-of-service',
      'meeting-info',
      'reschedule-info',
    ]);
    if (
      routePrefix &&
      segments.length === 1 &&
      !staticRoutes.has(routePrefix)
    ) {
      return this.checkMultiServiceFlag(
        FeatureFlagFieldType.FEATURE_FLAG_FIELD_TYPE_CALENDAR_ID,
        routePrefix
      );
    }

    return of(false);
  }

  private checkMultiServiceFlag(
    fieldType: FeatureFlagFieldType,
    fieldValue: string
  ): Observable<boolean> {
    return this.bookmenowService
      .checkFeatureFlag({
        fieldType,
        fieldValue,
        featureFlagKey: 'meeting_scheduler_multi_service_ui',
      })
      .pipe(catchError(() => of(false)));
  }
}
